import axios from 'axios';

let url = '/api/v1';
if (location.hostname === "localhost" || location.hostname === "127.0.0.1") {
    url = 'https://81ubo5ayg8.execute-api.eu-west-3.amazonaws.com/api/v1'
}

export default axios.create({
    baseURL: url,
    params: {
        // API params go here
    }
});
